import { refineServiceDecorator } from 'monaco-editor/esm/vs/platform/instantiation/common/instantiation.js';
import { ILayoutService } from 'monaco-editor/esm/vs/platform/layout/browser/layoutService.js';
const IWorkbenchLayoutService = refineServiceDecorator(ILayoutService);
var Parts;
( (function(Parts) {
    Parts["TITLEBAR_PART"] = "workbench.parts.titlebar";
    Parts["BANNER_PART"] = "workbench.parts.banner";
    Parts["ACTIVITYBAR_PART"] = "workbench.parts.activitybar";
    Parts["SIDEBAR_PART"] = "workbench.parts.sidebar";
    Parts["PANEL_PART"] = "workbench.parts.panel";
    Parts["AUXILIARYBAR_PART"] = "workbench.parts.auxiliarybar";
    Parts["EDITOR_PART"] = "workbench.parts.editor";
    Parts["STATUSBAR_PART"] = "workbench.parts.statusbar";
})(Parts || (Parts = {})));
var Position;
( (function(Position) {
    Position[Position["LEFT"] = 0] = "LEFT";
    Position[Position["RIGHT"] = 1] = "RIGHT";
    Position[Position["BOTTOM"] = 2] = "BOTTOM";
})(Position || (Position = {})));
function positionToString(position) {
    switch (position) {
        case 0 : return 'left';
        case 1 : return 'right';
        case 2 : return 'bottom';
        default: return 'bottom';
    }
}
const positionsByString = {
    [positionToString(0 )]: 0 ,
    [positionToString(1 )]: 1 ,
    [positionToString(2 )]: 2
};
function positionFromString(str) {
    return positionsByString[str];
}
export { IWorkbenchLayoutService, Parts, Position, positionFromString, positionToString };
